// Libraries
import styled from "styled-components"


export const GeneralInfoDescriptionContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
`

